module.exports = __webpack_public_path__ + "static/img/ico_kakaostory.640b244.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/myprotein-test/assets/images/ico/ico_kakaostory.svg
// module id = 3bLo
// module chunks = 0